import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"width":"450px","height":"calc(100vh - 330px)"} }
const _hoisted_5 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_7 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_8 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GuestSelector = _resolveComponent("GuestSelector")
  const _component_BuildingSelector = _resolveComponent("BuildingSelector")
  const _component_ApartmentSelector = _resolveComponent("ApartmentSelector")
  const _component_AddBadgePage = _resolveComponent("AddBadgePage")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDialogVisible = $event)),
    onHide: _ctx.doHideDialog,
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom add-badge_dialog"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          (_ctx.step === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                (_ctx.guestBadge)
                  ? (_openBlock(), _createBlock(_component_GuestSelector, {
                      key: 0,
                      onGuestSelected: _ctx.selectGuest
                    }, null, 8, ["onGuestSelected"]))
                  : (_openBlock(), _createBlock(_component_BuildingSelector, {
                      key: 1,
                      onBuildingSelected: _ctx.selectBuilding
                    }, null, 8, ["onBuildingSelected"]))
              ]))
            : _createCommentVNode("", true),
          (_ctx.step === 1)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_ApartmentSelector, {
                  selectedBuilding: _ctx.selectedBuilding,
                  onApartmentSelected: _ctx.selectApartment
                }, null, 8, ["selectedBuilding", "onApartmentSelected"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.step === 2)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode(_component_AddBadgePage, {
                  gateGuest: _ctx.selectedGuest,
                  apartment: _ctx.selectedApartment,
                  badgesList: _ctx.badgesList,
                  plantBadges: _ctx.plantBadges,
                  onAddBadge: _ctx.addBadge,
                  onRemoveBadge: _ctx.removeBadge
                }, null, 8, ["gateGuest", "apartment", "badgesList", "plantBadges", "onAddBadge", "onRemoveBadge"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("footer", _hoisted_8, [
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          label: _ctx.secondaryButtonLabel,
          onClick: _ctx.handleSecondaryButtonAction
        }, null, 8, ["label", "onClick"]),
        (_ctx.step !== 0)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: _ctx.buttonSubmitLabel,
              onClick: _ctx.handleButtonSubmitAction,
              class: "p-button-rounded p-button-raised p-button--m",
              disabled: _ctx.saveButtonDisabled
            }, null, 8, ["label", "onClick", "disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}